module.exports = __webpack_public_path__ + "img/couponY.deed0077.png";